import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import {
  BaseDialog,
  BaseForm,
  BaseFormRef,
  BaseFormItem,
  BaseInput,
  BaseFormProps,
  BaseTextContent,
  BaseButton,
  XrkMessage
} from 'xrk-components';
import { validatorPassword } from '@/utils/validator';
import { setAPassword2 } from '@/common/data-source/user/apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'change-password',
  props: {
    remove: {}
  },
  emits: ['success'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;

const formRef = ref<BaseFormRef>();
const formData = ref({
  password: '',
  passwordTwo: ''
});
const rules = ref<BaseFormProps['rules']>({
  password: [
    {
      required: true,
      trigger: 'blur',
      validator: (...arg) => validatorPassword(...arg, '请输入新密码')
    }
  ],
  passwordTwo: [
    {
      required: true,
      trigger: 'blur',
      validator: (_rule, value, callback) => {
        if (!value) {
          callback(new Error('请再次输入新密码'));
        } else if (formData.value.password !== value) {
          callback(new Error('您的新密码和确认密码不一致，请重新输入'));
        } else {
          callback();
        }
      }
    }
  ]
});

const onCancel = () => {
  props.remove();
};

const onConfirm = async () => {
  try {
    await formRef.value.validate();
    await setAPassword2(formData.value);
    onCancel();
    XrkMessage.success('用户重置密码成功');
    emits('success');
  } catch (error) {
    console.log(error);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    class: "employee-management-add",
    title: "重置密码",
    width: "450px",
    "model-value": true
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("返回")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), { onClick: onConfirm }, {
        default: _withCtx(() => [
          _createTextVNode("保存")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseForm), {
            ref_key: "formRef",
            ref: formRef,
            model: formData.value,
            rules: rules.value,
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseFormItem), {
                label: "请输入新密码",
                prop: "password"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    style: {"width":"100%"},
                    type: "password",
                    autocomplete: "off",
                    placeholder: "请输入新密码",
                    "show-password": "",
                    clearable: true,
                    maxlength: 8,
                    modelValue: formData.value.password,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.password) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BaseFormItem), {
                label: "请再次输入新密码",
                prop: "passwordTwo"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    style: {"width":"100%"},
                    type: "password",
                    autocomplete: "off",
                    placeholder: "请再次输入新密码",
                    "show-password": "",
                    clearable: true,
                    maxlength: 8,
                    modelValue: formData.value.passwordTwo,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.passwordTwo) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})